<template>
  <div class="lds-spinner__wrapper" :class="[fixed ? 'lds-spinner__wrapper--fixed' : '']">
    <div class="lds-spinner">
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
      <div :style="{'color': color}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    fixed: {
      default: false
    },
    color: {
      default: "#000000"
    }
  },
  methods: {

  },
  computed: {
    
  }
}
</script>

<style lang="scss" scoped>
.lds-spinner__wrapper{
  &--fixed{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255,255,255,0.9);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100;
  }
}
.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-spinner div {
  transform-origin: 32px 32px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 29px;
  width: 5px;
  height: 14px;
  border-radius: 20%;
  background: currentColor;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>